import { LOANREQUEST_BUCKETS, ORGANIZATIONS, USER_ROLES } from 'cpool-constants';
import { z } from 'zod';

import { schemaUserCommon } from './userCommon';
import { schemaId } from '../../utils/schema.utils';

export const schemaCorporationDirector = z
    .object({
        buckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)).optional(),
        // deprecated: legacy assignment field, group membership lives on the group aggregates
        corporationId: schemaId.optional(),
        organization: z.nativeEnum(ORGANIZATIONS),
        ownedBuckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)).optional(),
        role: z.literal(USER_ROLES.corporation_director),
    })
    .merge(schemaUserCommon);
